var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMental04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1669 16.3752L27.0419 27.0002M27.0419 27.0002L7.91692 16.3752M27.0419 27.0002L27.042 48.3753M47.292 36.1321V17.8686C47.292 17.0976 47.292 16.7121 47.1784 16.3683C47.0779 16.0642 46.9136 15.785 46.6966 15.5495C46.4512 15.2832 46.1142 15.096 45.4403 14.7216L28.7903 5.4716C28.1522 5.11709 27.8331 4.93984 27.4953 4.87035C27.1962 4.80884 26.8878 4.80884 26.5887 4.87035C26.2508 4.93984 25.9318 5.11709 25.2937 5.4716L8.64368 14.7216C7.96975 15.096 7.63278 15.2832 7.38742 15.5495C7.17035 15.785 7.00607 16.0642 6.90558 16.3684C6.79199 16.7121 6.79199 17.0976 6.79199 17.8686V36.1321C6.79199 36.903 6.79199 37.2885 6.90558 37.6323C7.00607 37.9364 7.17035 38.2156 7.38742 38.4512C7.63278 38.7174 7.96975 38.9046 8.64368 39.279L25.2937 48.529C25.9318 48.8835 26.2508 49.0608 26.5887 49.1303C26.8878 49.1918 27.1962 49.1918 27.4953 49.1303C27.8331 49.0608 28.1522 48.8835 28.7903 48.529L45.4403 39.279C46.1142 38.9046 46.4512 38.7174 46.6966 38.4512C46.9136 38.2156 47.0779 37.9364 47.1784 37.6323C47.292 37.2885 47.292 36.903 47.292 36.1321Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMental04);
export default __webpack_public_path__ + "static/media/mental04.f4e32eb646e99785925a829596cec1f0.svg";
export { ForwardRef as ReactComponent };